module.exports = __webpack_public_path__ + "img/GM.d01a8ce4.svg";